const port = localStorage.getItem("Port");
const socket_port = localStorage.getItem("socket_port");


// export const socket_url = `http://http://localhost:8800/backend/`;
// export const socket_url_web = `http://http://localhost:8800/`;
// export const base_url = `${window.location.origin}/backend/`;



// export const base_url = `http://localhost:8800/`;
// export const socket_url = `https://trade.tradestreet.in:1003/`;
// export const socket_url_web = `https://trade.tradestreet.in:1002/`;




// BUILD CONFIGURATION  for live all panel


export const base_url = window.location.hostname === "localhost" ? `http://localhost:8800/` : `${window.location.origin}/backend/`;
export const getSocketUrl = () => {
  const port = localStorage.getItem("Port");
  return window.location.hostname === "localhost" ? `http://localhost:8800/` : port ? `https://${window.location.hostname}:${port}` : `https://${window.location.hostname}`;
};
export const getSocketUrlWeb = () => {
  const s_port = localStorage.getItem("socket_port");
  return window.location.hostname === "localhost" ? `http://localhost:8800/` : s_port ? `https://${window.location.hostname}:${s_port}` : `https://${window.location.hostname}`;
};





   